<template>
  <div class="client">
    <v-app id="client">
      <v-content>
        <v-carousel hide-delimiters show-arrows-on-hover cycle height="400">
          <v-carousel-item v-for="item in items" :key="item.id" :src="item.src">        
            <v-card-title class="align-end fill-height white--text ml-10 logo">
              <v-list-item>
                <v-list-item-avatar>
                  <img src="@/assets/googleicon.png" alt="Google" width="40" />
                </v-list-item-avatar>
              </v-list-item>
            </v-card-title>
            <mapdirection/>
            <v-card-title class="align-end fill-height white--text ml-10 main-title">
                <b class="main-title-text">Client Name</b>
            </v-card-title>
            <v-card-title class="align-end fill-height white--text ml-10 title">
                <b class="title-text">{{ item.title }}</b>
            </v-card-title>
            <v-card-title class="align-end fill-height white--text">
              <v-breadcrumbs :items="breadcrumbs" :to="breadcrumbs.to">
                <template v-slot:divider>
                  <v-icon>mdi-forward</v-icon>
                </template>
              </v-breadcrumbs>
            </v-card-title>
          </v-carousel-item>
        </v-carousel>
        <v-tabs dark background-color="transparent">
          <v-tab><b class="label">Products</b></v-tab><!--IF APPLICABLE -->
          <v-tab><b class="label">Services</b></v-tab><!--IF APPLICABLE -->
          <v-tab><b class="label">Events</b></v-tab><!--IF APPLICABLE -->
          <v-tab><b class="label">About us</b></v-tab>
          <v-tab-item>
            <v-container fluid fill-height>
              <v-layout>
                <div class="columns is-multiline">
                  <div class="column is-12">
                    <v-layout>
                      <v-flex xs2>
                        <v-card-title>Filter |</v-card-title>
                      </v-flex>
                      <v-flex xs3>
                        <v-select :items="subcategories" label="Categories"></v-select>
                      </v-flex>
                      <v-flex xs1>
                      </v-flex>
                      <v-flex xs3>
                         <v-text-field v-model="search" append-icon="mdi-magnify" label="Search Client Products" single-line hide-details></v-text-field>
                      </v-flex>
                      <v-flex xs1>
                      </v-flex>
                      <v-flex xs3>
                         <v-switch v-model="tick" label="Show Only Sale Items" color="indigo darken-3" value="" hide-details></v-switch>
                      </v-flex>
                    </v-layout>
                  </div>
                  <div class="column is-3">
                    <v-flex xs12>
                      <v-card class="elevation-6"  style="margin-left: 5px; margin-right: 5px;">
                        <router-link to="/product/:slug"><v-img height="230" src="@/assets/256x256.png"  responsive lazy-src="@/assets/256x256.png"></v-img>
                        <v-card-title>Product 1</v-card-title></router-link>
                          <v-card-text>
                            <v-layout align-center>
                              <v-rating :value="4.5" color="amber" half-increments dense size="14" readonly></v-rating>
                              <div class="grey--text ml-4">4.5 (413)</div>
                            </v-layout>
                            <div class="my-4 subtitle-1 black--text">
                              <span class="label">Client 1,  location 1</span>
                            </div>
                            <div class="label"  style="margin-top: 0px; padding-top: 0px;">Price 1  |  
                              <add-to-cart   />
                            </div>
                          </v-card-text>
                      </v-card>
                    </v-flex>
                  </div>
                  <div class="column is-3">
                    <v-flex xs12>
                      <v-card class="elevation-6"  style="margin-left: 5px; margin-right: 5px;">
                        <router-link to="/product/:slug"><v-img height="230" src="@/assets/256x256.png"  responsive lazy-src="@/assets/256x256.png"></v-img>
                        <v-card-title>Product 1</v-card-title></router-link>
                          <v-card-text>
                            <v-layout align-center>
                              <v-rating :value="4.5" color="amber" half-increments dense size="14" readonly></v-rating>
                              <div class="grey--text ml-4">4.5 (413)</div>
                            </v-layout>
                            <div class="my-4 subtitle-1 black--text">
                              <span class="label">Client 1,  location 1</span>
                            </div>
                            <div class="label"  style="margin-top: 0px; padding-top: 0px;">Price 1  |  
                              <add-to-cart   />
                            </div>
                          </v-card-text>
                      </v-card>
                    </v-flex>
                  </div>
                  <div class="column is-3">
                    <v-flex xs12>
                      <v-card class="elevation-6"  style="margin-left: 5px; margin-right: 5px;">
                        <router-link to="/product/:slug"><v-img height="230" src="@/assets/256x256.png"  responsive lazy-src="@/assets/256x256.png"></v-img>
                        <v-card-title>Product 1</v-card-title></router-link>
                          <v-card-text>
                            <v-layout align-center>
                              <v-rating :value="4.5" color="amber" half-increments dense size="14" readonly></v-rating>
                              <div class="grey--text ml-4">4.5 (413)</div>
                            </v-layout>
                            <div class="my-4 subtitle-1 black--text">
                              <span class="label">Client 1,  location 1</span>
                            </div>
                            <div class="label"  style="margin-top: 0px; padding-top: 0px;">Price 1  |  
                              <add-to-cart   />
                            </div>
                          </v-card-text>
                      </v-card>
                    </v-flex>
                  </div>
                  <div class="column is-3">
                    <v-flex xs12>
                      <v-card class="elevation-6"  style="margin-left: 5px; margin-right: 5px;">
                        <router-link to="/product/:slug"><v-img height="230" src="@/assets/256x256.png"  responsive lazy-src="@/assets/256x256.png"></v-img>
                        <v-card-title>Product 1</v-card-title></router-link>
                          <v-card-text>
                            <v-layout align-center>
                              <v-rating :value="4.5" color="amber" half-increments dense size="14" readonly></v-rating>
                              <div class="grey--text ml-4">4.5 (413)</div>
                            </v-layout>
                            <div class="my-4 subtitle-1 black--text">
                              <span class="label">Client 1,  location 1</span>
                            </div>
                            <div class="label"  style="margin-top: 0px; padding-top: 0px;">Price 1  |  
                              <add-to-cart   />
                            </div>
                          </v-card-text>
                      </v-card>
                    </v-flex>
                  </div>
                </div>
              </v-layout>
            </v-container>
          </v-tab-item>
          <v-tab-item>
            <v-container fluid fill-height>
              <v-layout>
                <div class="columns is-multiline">
                  <div class="column is-12">
                    <v-layout>
                      <v-flex xs2>
                        <v-card-title>Filter |</v-card-title>
                      </v-flex>
                      <v-flex xs3>
                        <v-select :items="subcategories" label="Sub Services"></v-select>
                      </v-flex>
                      <v-flex xs2>
                      </v-flex>
                      <v-flex xs3>
                         <v-text-field v-model="search" append-icon="mdi-magnify" label="Search Events" single-line hide-details></v-text-field>
                      </v-flex> 
                    </v-layout>
                  </div>
                  <div class="column is-3">
                    <v-flex xs12>
                      <v-card class="elevation-4">
                        <router-link to="/service/:slug"><v-img height="180" src="@/assets/256x256.png"  responsive lazy-src="@/assets/256x256.png">
                          <v-card-title class="align-end fill-height">
                            Service Name
                          </v-card-title>
                        </v-img></router-link>
                        <v-card-text>
                          <v-layout align-center>
                            <v-rating :value="4.0" color="amber" half-increments dense size="18" readonly></v-rating><div class="black--text ml-2">4.5 (413)</div>
                          </v-layout>
                          <div class="my-4 subtitle-1 black--text">
                            <div class="subtitle-2 black--text">
                              Sub Services (4)
                            </div>
                            <span class="label">
                              Client  | location | Like
                            </span>
                          </div>
                        </v-card-text>
                      </v-card>
                    </v-flex>
                  </div>
                  <div class="column is-3">
                    <v-flex xs12>
                      <v-card class="elevation-4">
                        <router-link to="/service/:slug"><v-img height="180" src="@/assets/256x256.png"  responsive lazy-src="@/assets/256x256.png">
                          <v-card-title class="align-end fill-height">
                            Service Name
                          </v-card-title>
                        </v-img></router-link>
                        <v-card-text>
                          <v-layout align-center>
                            <v-rating :value="4.0" color="amber" half-increments dense size="18" readonly></v-rating><div class="black--text--text ml-2">4.5 (413)</div>
                          </v-layout>
                          <div class="my-4 subtitle-1 black--text">
                            <div class="subtitle-2 black--text">
                              Sub Services (4)
                            </div>
                            <span class="label">
                              Client  | location | Like
                            </span>
                          </div>
                        </v-card-text>
                      </v-card>
                    </v-flex>
                  </div>
                  <div class="column is-3">
                    <v-flex xs12>
                      <v-card class="elevation-4">
                        <router-link to="/service/:slug"><v-img height="180" src="@/assets/256x256.png"  responsive lazy-src="@/assets/256x256.png">
                          <v-card-title class="align-end fill-height">
                            Service Name
                          </v-card-title>
                        </v-img></router-link>
                        <v-card-text>
                          <v-layout align-center>
                            <v-rating :value="4.0" color="amber" half-increments dense size="18" readonly></v-rating><div class="black--text--text ml-2">4.5 (413)</div>
                          </v-layout>
                          <div class="my-4 subtitle-1 black--text">
                            <div class="subtitle-2 black--text">
                              Sub Services (4)
                            </div>
                            <span class="label">
                              Client  | location | Like
                            </span>
                          </div>
                        </v-card-text>
                      </v-card>
                    </v-flex>
                  </div>
                  <div class="column is-3">
                    <v-flex xs12>
                      <v-card class="elevation-4">
                        <router-link to="/service/:slug"><v-img height="180" src="@/assets/256x256.png"  responsive lazy-src="@/assets/256x256.png">
                          <v-card-title class="align-end fill-height">
                            Service Name
                          </v-card-title>
                        </v-img></router-link>
                        <v-card-text>
                          <v-layout align-center>
                            <v-rating :value="4.0" color="amber" half-increments dense size="18" readonly></v-rating><div class="black--text--text ml-2">4.5 (413)</div>
                          </v-layout>
                          <div class="my-4 subtitle-1 black--text">
                            <div class="subtitle-2 black--text">
                              Sub Services (4)
                            </div>
                            <span class="label">
                              Client  | location | Like
                            </span>
                          </div>
                        </v-card-text>
                      </v-card>
                    </v-flex>
                  </div>
                </div>
              </v-layout>
            </v-container>
          </v-tab-item>
          <v-tab-item>
            <v-container fluid fill-height>
              <v-layout>
                <div class="columns is-multiline">
                  <div class="column is-12">
                    <v-layout>
                      <v-flex xs2>
                        <v-card-title>Filter |</v-card-title>
                      </v-flex>
                      <v-flex xs3>
                        <v-switch v-model="tick" label="Show Only Free Events" color="indigo darken-3" value="" hide-details></v-switch>
                      </v-flex>
                      <v-flex xs3>
                         <v-text-field v-model="search" append-icon="mdi-magnify" label="Search Events" single-line hide-details></v-text-field>
                      </v-flex> 
                    </v-layout>
                  </div>
                  <div class="column is-3">
                    <v-flex xs12>
                      <v-card class="elevation-6"  style="margin-left: 5px; margin-right: 5px;">
                        <router-link to="/event/:slug"><v-img height="230" src="@/assets/256x256.png"  responsive lazy-src="@/assets/256x256.png" class="white--text">
                          <v-card-title class="align-end fill-height">
                            Event Name
                          </v-card-title>
                        </v-img></router-link>
                        <v-card-title>location 1</v-card-title>
                          <v-card-text>
                            <div class="my-4 subtitle-1 black--text">
                              <span class="label">Client 1 </span> 
                            </div>
                            <div class="label"  style="margin-top: 0px; padding-top: 0px;"><span class="label">Date 1 |  Price |  <add-to-cart /></span> 
                              
                            </div>
                          </v-card-text>
                      </v-card>
                    </v-flex>
                  </div>
                  <div class="column is-3">
                    <v-flex xs12>
                      <v-card class="elevation-6"  style="margin-left: 5px; margin-right: 5px;">
                        <router-link to="/event/:slug"><v-img height="230" src="@/assets/256x256.png"  responsive lazy-src="@/assets/256x256.png" class="white--text">
                          <v-card-title class="align-end fill-height">
                            Event Name
                          </v-card-title>
                        </v-img></router-link>
                        <v-card-title>location 1</v-card-title>
                          <v-card-text>
                            <div class="my-4 subtitle-1 black--text">
                              <span class="label">Client 1 </span> 
                            </div>
                            <div class="label"  style="margin-top: 0px; padding-top: 0px;"><span class="label">Date 1 |  Price |  <add-to-cart /></span> 
                              
                            </div>
                          </v-card-text>
                      </v-card>
                    </v-flex>
                  </div>
                  <div class="column is-3">
                    <v-flex xs12>
                      <v-card class="elevation-6"  style="margin-left: 5px; margin-right: 5px;">
                        <router-link to="/event/:slug"><v-img height="230" src="@/assets/256x256.png"  responsive lazy-src="@/assets/256x256.png" class="white--text">
                          <v-card-title class="align-end fill-height">
                            Event Name
                          </v-card-title>
                        </v-img></router-link>
                        <v-card-title>location 1</v-card-title>
                          <v-card-text>
                            <div class="my-4 subtitle-1 black--text">
                              <span class="label">Client 1 </span> 
                            </div>
                            <div class="label"  style="margin-top: 0px; padding-top: 0px;"><span class="label">Date 1 |  Price |  <add-to-cart /></span> 
                              
                            </div>
                          </v-card-text>
                      </v-card>
                    </v-flex>
                  </div>
                  <div class="column is-3">
                    <v-flex xs12>
                      <v-card class="elevation-6"  style="margin-left: 5px; margin-right: 5px;">
                        <router-link to="/event/:slug"><v-img height="230" src="@/assets/256x256.png"  responsive lazy-src="@/assets/256x256.png" class="white--text">
                          <v-card-title class="align-end fill-height">
                            Event Name
                          </v-card-title>
                        </v-img></router-link>
                        <v-card-title>location 1</v-card-title>
                          <v-card-text>
                            <div class="my-4 subtitle-1 black--text">
                              <span class="label">Client 1 </span> 
                            </div>
                            <div class="label"  style="margin-top: 0px; padding-top: 0px;"><span class="label">Date 1 |  Price |  <add-to-cart /></span> 
                              
                            </div>
                          </v-card-text>
                      </v-card>
                    </v-flex>
                  </div>
                </div>
              </v-layout>
            </v-container>
          </v-tab-item>
          <v-tab-item>
            <servicecarousel />
          </v-tab-item>
        </v-tabs>
      </v-content>
    </v-app>
  </div>
</template>

<script>
  import mapdirection from '@/components/Client/map.vue' 
  export default {
    name: 'client',
    data: () => ({
      dialog: false,
      items: [
          {
            src: 'https://cdn.vuetifyjs.com/images/carousel/squirrel.jpg',
            title: 'Description One' // Perhaps Their Slogan
          },
          {
            src: 'https://cdn.vuetifyjs.com/images/carousel/sky.jpg',
            title: 'Description Two'
          },
          {
            src: 'https://cdn.vuetifyjs.com/images/carousel/planet.jpg',
            title: 'Description Three'
          },
      ],
      cuisines : [
        'All',
        'Indian',
        'Chinese',
        'African',
        'Italian',
        'Indian'
      ],
      breadcrumbs: [
        {
          text: 'Home',
          disabled: false,
          to: '/'
        },
        {
          text: 'Client Category',
          disabled: false,
          to: '/c/categories/:slug'
        },
        {
          text: 'Client Page',
          disabled: true
        },
      ],
      slider: [30, 60]
    }),
    components: {
      mapdirection
    }
  }
</script>

<style scoped>
  .logo {
    position: absolute;
    bottom: 280px;
  }
  .map {
    position: absolute;
    bottom: 300px;
    left: 80%;
  }
  .main-title {
    position: absolute;
    bottom: 100px;
  }
  .title {
    position: absolute;
    bottom: 40px;
  }
  .main-title-text {
    font-size: 35px;
  }
  .title-text {
    font-size: 25px;
  }
  .left {
    float: right;
  }
</style>
